import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';

@Component({
    selector: 'app-archive-external-access',
    templateUrl: './archive-external-access.component.html',
    styleUrls: ['./archive-external-access.component.scss'],
    standalone: false
})
export class ArchiveExternalAccessComponent implements OnInit {

  constructor() { }
  public logVisible = true;
  public configVisible = false;
  ngOnInit(): void {
  }

  onConfigClick($event) {
    this.configVisible = true;
    this.logVisible = false;
    $event.currentTarget.blur();
  }
  onLogClick($event) {
    this.logVisible = true;
    this.configVisible = false;
    $event.currentTarget.blur();
  }
}
